"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Wed Aug 22 2018
 */

var big_decimal_1 = require("@logio/big-decimal");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var BigNumberGreaterThanValidator_1 = require("../../core/model/data-dictionary/validators/BigNumberGreaterThanValidator");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>
 *     Entity encapsulates bound between {@link Product internal product} and {@link CompetitorProduct competitor product}. Quality or
 *     size difference between the two is determined by:
 * </p>
 *
 * <ul>
 *     <li>{@link CompetitorProductBinding.sizeCharger}</li>
 *     <li>{@link CompetitorProductBinding.sizeRatio}</li>
 * </ul>
 *
 * @author RV
 */


var CompetitorProductBinding =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorProductBinding, _DomainObject_1$Domai);

  /**
   * @param id internal id of entity holding the bound of internal product and competitor product
   * @param competitorProductId corresponds to {@link CompetitorProduct.id internal id of competitor product}
   * @param internalProductId corresponds to {@link Product.id internal id of internal product}
   * @param recommended Flag which marking, whether is pair product - competitor's product approved by user or not
   * @param sizeCharger meaning should be the same as {@link ProductBinding.sizeCharger}
   * @param sizeRatio meaning should be the same as {@link ProductBinding.sizeRatio}
   */
  function CompetitorProductBinding(id, competitorProductId, internalProductId, recommended, sizeCharger, sizeRatio) {
    var _this;

    _classCallCheck(this, CompetitorProductBinding);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductBinding).call(this));
    _this.id = id;
    _this.competitorProductId = competitorProductId;
    _this.internalProductId = internalProductId;
    _this.recommended = recommended;
    _this.sizeCharger = sizeCharger;
    _this.sizeRatio = sizeRatio;
    return _this;
  }

  return CompetitorProductBinding;
}(DomainObject_1.DomainObject);

exports.CompetitorProductBinding = CompetitorProductBinding; // tslint:disable-next-line:member-ordering

CompetitorProductBinding.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorProductBinding.name);
  return {
    id: builder.id('id'),
    competitorProductId: builder.str('competitorProductId'),
    internalProductId: builder.str('internalProductId'),
    recommended: builder.bool('recommended'),
    sizeCharger: builder.bigNum('sizeCharger', new BigNumberGreaterThanValidator_1.BigNumberGreaterThanValidator(big_decimal_1.bigdecimal(-100))),
    sizeRatio: builder.bigNum('sizeRatio')
  };
}();